import * as betgalaxy from './Form.styles.betgalaxy';
import * as betprofessor from './Form.styles.betprofessor';
import * as betroyale from './Form.styles.betroyale';
import * as fiestabet from './Form.styles.fiestabet';
import * as goldenrush from './Form.styles.goldenrush';
import * as puntcity from './Form.styles.puntcity';
import * as puntgenie from './Form.styles.puntgenie';
import * as questbet from './Form.styles.questbet';
import * as sterlingparker from './Form.styles.sterlingparker';
import * as vikingbet from './Form.styles.vikingbet';
import * as volcanobet from './Form.styles.volcanobet';
import * as wellbet from './Form.styles.wellbet';
import * as juicybet from './Form.styles.juicybet';
import * as junglebet from './Form.styles.junglebet';
import * as forsport from './Form.styles.forsport';
import * as oldgill from './Form.styles.oldgill';
import * as sugarcastle from './Form.styles.sugarcastle';
import * as buffalobet from './Form.styles.buffalobet';
import * as titanbet from './Form.styles.titanbet';
import * as slambet from './Form.styles.slambet';
import * as gigabet from './Form.styles.gigabet';
import * as betstride from './Form.styles.betstride';
import * as templebet from './Form.styles.templebet';
import * as goldenbet888 from './Form.styles.goldenbet888';
import * as hyperbet from './Form.styles.hyperbet';
import * as bet777 from './Form.styles.bet777';
import * as chromabet from './Form.styles.chromabet';
import * as bet575 from './Form.styles.bet575';
import * as epicodds from './Form.styles.epicodds';
import * as pyramidbet from './Form.styles.pyramidbet';
import * as magnumbet from './Form.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  junglebet,
  forsport,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
